import type { SpreadLayoutTemplate } from './layout-types';

export const CELTIC_CROSS_10_LAYOUT: SpreadLayoutTemplate = {
  id: 'celtic-cross-10',
  family: 'cross',
  cards: 10,
  description: 'Croce Celtica completa con centro incrociato e colonna laterale verticale.',
  supports_focus_overlay: true,
  variants: [
    {
      id: 'portrait',
      points: [
        { x: 34, y: 50, z: 2 },
        { x: 34, y: 50, z: 3 },
        { x: 34, y: 20, z: 1 },
        { x: 34, y: 80, z: 1 },
        { x: 16, y: 50, z: 1 },
        { x: 52, y: 50, z: 1 },
        { x: 78, y: 84, z: 1 },
        { x: 78, y: 64, z: 1 },
        { x: 78, y: 44, z: 1 },
        { x: 78, y: 24, z: 1 },
      ],
      card_rotation: [0, 90, 0, 0, 0, 0, 0, 0, 0, 0],
      card_scale: [1, 0.95, 1, 1, 1, 1, 0.96, 0.96, 0.96, 0.96],
    },
    {
      id: 'compact',
      points: [
        { x: 32, y: 52, z: 2 },
        { x: 32, y: 52, z: 3 },
        { x: 32, y: 26, z: 1 },
        { x: 32, y: 78, z: 1 },
        { x: 16, y: 52, z: 1 },
        { x: 48, y: 52, z: 1 },
        { x: 78, y: 82, z: 1 },
        { x: 78, y: 62, z: 1 },
        { x: 78, y: 42, z: 1 },
        { x: 78, y: 22, z: 1 },
      ],
      card_rotation: [0, 90, 0, 0, 0, 0, 0, 0, 0, 0],
      card_scale: [0.95, 0.9, 0.95, 0.95, 0.95, 0.95, 0.92, 0.92, 0.92, 0.92],
    },
  ],
};
